import { useState, useRef } from 'react'
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { createTheme, MenuItem, ThemeProvider, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress'; 

const theme = createTheme({
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
              fontFamily: 'Roboto medium, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '500'
            },
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            '&.MuiTypography-root': {
              fontFamily: 'Roboto regular, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '400'
            },
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontFamily: 'Roboto medium, Helvetica, Arial, sans-serif',
            fontSize:'14px',
            fontWeight: '500'
          },
        },
      },
    },
  });


const AutoCompleteInput = ({tag, obj, setObj, func,  list, width, font, topAlignTypography=false}) => {
    // initialize state
    const [showSpinner, setShowSpinner] = useState(false); 
    // initialize ref
    // const block = useRef(true); 

    // set width if not passed as prop
    if (width == null){
        width = '16.6vw';
    }
    // set font size if given as prop, else use default
    let style = {};
    if (font){
        style['fontSize'] = font; 
    }

    // event hander to change state variable when a dropdown value is click
    const onInputChange = (e, values) => {
        console.log(values); 
        // set values 
        setObj(obj => obj = values); 
        // show spinner
        setShowSpinner(showSpinner => showSpinner = true); 
        // call function on input change 
        func(values).then(res => {
            console.log(res); 
            // hide spinner 
            setShowSpinner(showSpinner => showSpinner = false); 
        }).catch(err => {
            console.log(err); 
            // hide spinner 
            setShowSpinner(showSpinner => showSpinner = false); 
        }); 
    }

    // // event handler to change state variable when textfield changes
    // const onTextFieldChange = (e) =>{
    //     setValue(value => value = e.target.value);
    // } 

    const filterOptions = createFilterOptions({
        stringify: ({ label, id }) => `${label}${id}`
    });

    return (
        <>
            {/* material ui autocomplete component */}
            <ThemeProvider theme={theme}>
                <div className={topAlignTypography ? 'd-flex flex-column align-items-start w-100' : 'd-flex gap-2 align-items-center w-100'}>
                    <Typography>
                        {tag}
                    </Typography>
                    <FormControl fullWidth size='small' sx={{ width: width }} >
                        <Autocomplete
                            value={obj}
                            options={list}
                            id="combo-box-demo"
                            size='small'
                            renderOption={(props, option) =>
                                <MenuItem key={option.id}
                                    sx={{ whiteSpace: "collapse", borderBottom: "1px solid #E6EDF1" }}
                                    {...props} style={style} >{option.label + '\n' + option.id}
                                </MenuItem>
                            }
                            getOptionsLabel={option => option.label}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    style={style}
                                    InputProps={{ ...params.InputProps, style: style }}
                                    InputLabelProps={{ style: style }}
                                    placeholder={'Search ' + tag}
                                />
                            }

                            onChange={(e, values) => onInputChange(e, values)}
                            disableClearable
                            filterOptions={filterOptions}
                        />
                    </FormControl>
                </div>
            </ThemeProvider>
            { showSpinner ? 
            <>
                <CircularProgress style={{height: '25px', width: '25px', marginTop: '5px', marginLeft: '10px', marginBottom: '-5px'}}/>
            </>
            :<></>}
        </>
        
    );
}

export default AutoCompleteInput;